import { render } from "./Toast.vue?vue&type=template&id=26ba6a58&ts=true"
import script from "./Toast.vue?vue&type=script&lang=ts"
export * from "./Toast.vue?vue&type=script&lang=ts"

import "./Toast.vue?vue&type=style&index=0&id=26ba6a58&lang=postcss"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__